import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {getBuild, getBuildType} from '../../../../selectors'
import {parseBranch} from '../../../../utils/branchNames'

import BuildPageHeader from './BuildPageHeader'
import type {OwnProps, StateProps} from './BuildPageHeader.types'

const mapStateToProps = (state: State, {buildId}: OwnProps): StateProps => {
  const build = getBuild(state, buildId)
  const {status, branchName, defaultBranch, buildType: buildTypeId} = build ?? {}
  const buildType = getBuildType(state, buildTypeId)
  return {
    buildTypeId,
    status,
    state: build?.state,
    personal: build?.personal,
    projectId: buildType?.projectId,
    buildTypeName: buildType?.name ?? '',
    branch: defaultBranch === true ? null : parseBranch(branchName),
  }
}

export default connect(mapStateToProps, {})(BuildPageHeader)
